export class User {
  constructor(param) {
    this.id = param.id || 0
    this.number = param.number || ''
    this.name = param.name || ''
  }
}
